module.exports = __webpack_public_path__ + "static/img/7.b4b8832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/7.png
// module id = zpFe
// module chunks = 0